import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faX } from "@fortawesome/free-solid-svg-icons";
import * as styles from "./header.module.css";

function scrollTo(href: string, offsetOverride?: number) {
  return () => {
    const header = document.getElementById("header");
    if (!header) return;

    const offset =
      offsetOverride !== undefined ? offsetOverride : header.offsetHeight;

    const element = document.getElementById(href);
    if (!element) return;
    const y =
      element.getBoundingClientRect().top + window.pageYOffset - offset - 5;

    window.scrollTo({ top: y, behavior: "smooth" });
  };
}

function scrollToMobile(href: string, offsetOverride?: number) {
  return () => {
    const header = document.getElementById("header");
    if (!header) return;

    menuClick();

    const offset =
      offsetOverride !== undefined ? offsetOverride : header.offsetHeight;

    const element = document.getElementById(href);
    if (!element) return;
    const y =
      element.getBoundingClientRect().top + window.pageYOffset - offset - 5;

    window.scrollTo({ top: y, behavior: "smooth" });
  };
}

function menuClick() {
  const openMenuIcon = document.getElementById("open-menu");
  const closeMenuIcon = document.getElementById("close-menu");
  const headerMenu = document.getElementById("header-menu");

  // Handle Closing the menu
  if (openMenuIcon?.classList.contains("hidden")) {
    // Icon
    openMenuIcon?.classList.remove("hidden");
    closeMenuIcon?.classList.add("hidden");

    // Menu
    headerMenu?.classList.add("hidden");
    return;
  }

  // Handle Opening the Menu

  // Icon
  openMenuIcon?.classList.add("hidden");
  closeMenuIcon?.classList.remove("hidden");

  // Menu
  headerMenu?.classList.remove("hidden");
}

const Header = () => {
  return (
    <header id="header" className={styles.header}>
      <div className={styles.headerLinkWrapper}>
        <button className="cursor-pointer" onClick={scrollTo("splash", 0)}>
          <StaticImage
            src="../../images/logo.png"
            alt="logo"
            width={65}
            height={65}
          />
        </button>
        <button className={styles.headerLink} onClick={scrollTo("discography")}>
          Discography
        </button>
        <button
          className={styles.headerLink}
          onClick={scrollTo("upcoming-shows")}
        >
          Upcoming Shows
        </button>
        <button className={styles.headerLink} onClick={scrollTo("past-shows")}>
          Past Shows
        </button>
        <button className={styles.headerLink} onClick={scrollTo("gallery")}>
          Gallery
        </button>
        <button className={styles.headerLink} onClick={scrollTo("contact")}>
          Contact
        </button>
        <button className={styles.headerLink} onClick={scrollTo("resources")}>
          EPK &amp; Rider
        </button>
      </div>
      <div className={styles.headerLinkWrapperMobile}>
        <button className={styles.headerMenuBtn} onClick={menuClick}>
          <FontAwesomeIcon id="open-menu" icon={faBars} />
          <FontAwesomeIcon id="close-menu" icon={faX} className="hidden" />
        </button>
        <a className="cursor-pointer" onClick={scrollToMobile("splash", 0)}>
          <StaticImage
            src="../../images/logo.png"
            alt="logo"
            className={styles.headerLogo}
            placeholder="none"
          />
        </a>
        <div className={styles.headerMenuBtn + " invisible"}>.</div>
      </div>
      <div id="header-menu" className={styles.headerMenuMobile + " hidden"}>
        <ul>
          <li className={styles.headerMenuItemMobile}>
            <button
              className={styles.headerLink}
              onClick={scrollToMobile("discography")}
            >
              Discography
            </button>
          </li>
          <li className={styles.headerMenuItemMobile}>
            <button
              className={styles.headerLink}
              onClick={scrollToMobile("upcoming-shows")}
            >
              Upcoming Shows
            </button>
          </li>
          <li className={styles.headerMenuItemMobile}>
            <button
              className={styles.headerLink}
              onClick={scrollToMobile("past-shows")}
            >
              Past Shows
            </button>
          </li>
          <li className={styles.headerMenuItemMobile}>
            <button
              className={styles.headerLink}
              onClick={scrollToMobile("gallery")}
            >
              Gallery
            </button>
          </li>
          <li className={styles.headerMenuItemMobile}>
            <button
              className={styles.headerLink}
              onClick={scrollToMobile("contact")}
            >
              Contact
            </button>
          </li>
          <li className={styles.headerMenuItemMobile}>
            <button
              className={styles.headerLink}
              onClick={scrollToMobile("resources")}
            >
              EPK &amp; Rider
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
